<template>
  <main>
    <section
      id="intro"
      class="main-row"
    >
      <b-container>
        <b-row>
          <b-col
            md="7"
            order="2"
            order-md="1"
            class="d-flex flex-column"
          >
            <h1 v-html="$t('meta.title')"></h1>
            <h2 v-html="$t('meta.lead')"></h2>
            <p class="actions">
              <a
                class="btn btn-lg btn-primary"
                :href="$t('intro.actions.convert.link')"
              >
                <i class="fas fa-rotate"></i>
                <span>{{ $t('intro.actions.convert.title') }}</span>
                <br />
                <small v-html="$t('intro.actions.convert.subtitle')"></small>
              </a>
              <a
                class="btn btn-lg btn-primary"
                :href="$t('intro.actions.other.link')"
              >
                <i class="fas fa-toolbox"></i>
                <span>{{ $t('intro.actions.other.title') }}</span>
                <br />
                <small v-html="$t('intro.actions.other.subtitle')"></small>
              </a>
            </p>
          </b-col>
          <b-col
            md="3"
            lg="4"
            order="1"
            order-md="2"
            class="d-flex justify-content-center align-items-center"
          >
            <img
              :src="`${$t('baseurl')}img/screens/toolbox.jpg`"
              alt=""
              class="img-fluid shadow-lg"
            />
          </b-col>
        </b-row>
        <b-row
          id="learn-more"
          aria-hidden="true"
          align-h="center"
          class="d-none d-sm-flex"
        >
          <input
            id="btn-learn-more"
            type="checkbox"
            class="sr-only"
            @change="$refs['what']
              .scrollIntoView({ behavior: 'smooth' })"
          />
          <label
            for="btn-learn-more"
            class="btn btn-sm btn-link p-0"
          >
            <span>En savoir plus</span>
            <i class="fas fa-lg fa-chevron-down d-block fc-g8"></i>
          </label>
        </b-row>
      </b-container>
    </section>

    <section
      id="what"
      ref="what"
    >
      <b-container>
        <b-row>
          <b-col>
            <h2 class="sr-only">
              {{ $t('what.title') }}
            </h2>
            <b-tabs
              align="center"
              card
              pills
            >
              <b-tab
                active
                class="p-0"
                :title="$t('what.tab1.label')"
              >
                <b-row>
                  <b-col
                    md="6"
                    lg="7"
                  >
                    <web-screen :img="`${$t('baseurl')}img/screens/simplicite.png`" />
                  </b-col>
                  <b-col
                    class="px-3"
                    md="6"
                    lg="5"
                    v-html="$t('what.tab1.desc')"
                  />
                </b-row>
              </b-tab>
              <b-tab
                class="p-0"
                :title="$t('what.tab2.label')"
              >
                <b-row>
                  <b-col
                    md="6"
                    lg="7"
                    order-md="2"
                  >
                    <web-screen :img="`${$t('baseurl')}img/screens/multifonction.png`" />
                  </b-col>

                  <b-col
                    class="px-3"
                    md="6"
                    lg="5"
                    v-html="$t('what.tab2.desc')"
                  />
                </b-row>
              </b-tab>
              <b-tab
                class="p-0"
                :title="$t('what.tab3.label')"
              >
                <b-row>
                  <b-col
                    md="6"
                    lg="7"
                  >
                    <web-screen :img="`${$t('baseurl')}img/screens/respectueux.png`" />
                  </b-col>

                  <b-col
                    class="px-3"
                    md="6"
                    lg="5"
                    v-html="$t('what.tab3.desc')"
                  />
                </b-row>
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <Limit />

    <how />

    <why />

    <who />

    <sfs />

    <outro />
  </main>
</template>

<script>
import WebScreen from '../../commons/components/WebScreen.vue';
import How from '../../commons/components/hos/How.vue';
import Why from '../../commons/components/hos/Why.vue';
import Who from '../../commons/components/hos/Who.vue';
import Outro from '../../commons/components/hos/Outro.vue';
import Sfs from '../../commons/components/sfs/Main.vue';
import Limit from './Home/Limit.vue';

export default {
  components: {
    WebScreen,
    How,
    Why,
    Who,
    Outro,
    Sfs,
    Limit,
  },
};
</script>

<style lang="scss">
#home {
  background: #fff
    url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="600px" height="600px" viewBox="0 0 100 100"><path d="M5.5 12a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM6 46a2 2 0 10.001-3.999A2 2 0 006 46zM31.5 8a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-3 30a2 2 0 10.001-3.999A2 2 0 0028.5 38zm16-10a2.5 2.5 0 000-5 2.5 2.5 0 000 5zM40 17.5a1 1 0 100-2 1 1 0 000 2zm-10 31a1 1 0 100-2 1 1 0 000 2zm-12.5-25a1 1 0 100-2 1 1 0 000 2zM77.53 24.742a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm-21.5-3.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm31.5 15.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-22.5 11.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm28-38a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-25 3.5a2 2 0 100-4 2 2 0 000 4zm23 35.5a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-37-16a1 1 0 100-2 1 1 0 000 2zM29.5 74a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM8 70.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM39.5 86a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM17 97.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm28-38a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM20 63a2 2 0 10.001-3.999A2 2 0 0020 63zm23 35.5a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-37-16a1 1 0 100-2 1 1 0 000 2zM77.53 74.242a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm-12.5 23.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm14.5-40a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-3 30a2 2 0 100-4 2 2 0 000 4zm14.5 11a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm1.5-21a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-4.5-10.5a1 1 0 100-2 1 1 0 000 2zm-34 15.5a1 1 0 100-2 1 1 0 000 2z" fill="%23e2e8f0" fill-opacity=".3"/></svg>');
  position: relative;
}

#intro {
  filter: drop-shadow(2px 5px 4px rgba(0, 0, 0, .2));
  padding: 1rem 0 3rem;
  position: relative;

  @media (max-width: 480px) {
    max-height: 645px;
  }

  &::before, &::after {
    display: block;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &::before {
    background: var(--f-f7);
    -webkit-clip-path: polygon(0 0, 0 100%, 100% 83%,  100% 0);
    clip-path: polygon(0 0, 0 100%, 100% 83%,  100% 0);

    @media (max-width: 768px) {
      -webkit-clip-path: polygon(0 0, 0 100%, 100% 93%,  100% 0);
      clip-path: polygon(0 0, 0 100%, 100% 93%,  100% 0);
    }

    // eslint-disable-next-line max-len
    background-image: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xml%3Aspace%3D%22preserve%22%20width%3D%22180%22%20height%3D%22180%22%3E%3Cpath%20d%3D%22M20.028%2016.632v1.605h6.42v-1.605a.322.322%200%200%200-.322-.321H20.35a.322.322%200%200%200-.321.32zm-1.926%201.605v-1.605a2.248%202.248%200%200%201%202.247-2.247h5.777a2.248%202.248%200%200%201%202.247%202.247v1.605h1.128c.51%200%20.999.204%201.36.565l2.082%202.083c.361.36.566.85.566%201.36v3.695h-5.136v-1.284c0-.71-.573-1.284-1.284-1.284-.71%200-1.284.574-1.284%201.284v1.284H20.67v-1.284c0-.71-.574-1.284-1.284-1.284-.71%200-1.284.574-1.284%201.284v1.284h-5.136v-3.695c0-.51.205-1%20.566-1.36l2.082-2.083c.361-.36.85-.565%201.36-.565zm-5.136%2011.555v-2.568h5.136c0%20.71.574%201.284%201.284%201.284.71%200%201.284-.574%201.284-1.284h5.135c0%20.71.574%201.284%201.284%201.284.71%200%201.284-.574%201.284-1.284h5.136v2.568a2.57%202.57%200%200%201-2.568%202.568H15.534a2.57%202.57%200%200%201-2.568-2.568zM72.337%2084.816v1.605h6.42v-1.605a.322.322%200%200%200-.321-.32h-5.778a.322.322%200%200%200-.32.32zm-1.926%201.605v-1.605a2.248%202.248%200%200%201%202.247-2.247h5.778a2.248%202.248%200%200%201%202.247%202.247v1.605h1.127c.51%200%201%20.205%201.36.566l2.083%202.082c.36.361.566.85.566%201.36v3.696h-5.136V92.84c0-.71-.574-1.284-1.284-1.284-.71%200-1.284.574-1.284%201.284v1.284h-5.136V92.84c0-.71-.574-1.284-1.284-1.284-.71%200-1.284.574-1.284%201.284v1.284h-5.135v-3.696c0-.51.204-.999.565-1.36l2.083-2.082c.36-.361.85-.566%201.36-.566zm-5.135%2011.555V95.41h5.135c0%20.71.574%201.283%201.284%201.283.71%200%201.284-.573%201.284-1.283h5.136c0%20.71.574%201.283%201.284%201.283.71%200%201.284-.573%201.284-1.283h5.136v2.567a2.57%202.57%200%200%201-2.568%202.568H67.844a2.57%202.57%200%200%201-2.568-2.568zM20.88%20158.032v1.604h6.419v-1.604a.322.322%200%200%200-.321-.321H21.2a.322.322%200%200%200-.32.32zm-1.927%201.604v-1.604a2.248%202.248%200%200%201%202.247-2.247h5.778a2.248%202.248%200%200%201%202.247%202.247v1.604h1.127c.51%200%201%20.205%201.36.566l2.083%202.083c.36.36.566.85.566%201.36v3.695h-5.136v-1.284c0-.71-.574-1.284-1.284-1.284-.71%200-1.284.574-1.284%201.284v1.284H21.52v-1.284c0-.71-.574-1.284-1.284-1.284-.71%200-1.284.574-1.284%201.284v1.284h-5.135v-3.695c0-.51.204-1%20.565-1.36l2.083-2.083c.36-.361.85-.566%201.36-.566zm-5.135%2011.556v-2.568h5.135c0%20.71.574%201.284%201.284%201.284.71%200%201.284-.574%201.284-1.284h5.136c0%20.71.574%201.284%201.284%201.284.71%200%201.284-.574%201.284-1.284h5.136v2.568a2.57%202.57%200%200%201-2.568%202.568H16.386a2.57%202.57%200%200%201-2.568-2.568zM120.062%20153.247v1.605h6.42v-1.605a.322.322%200%200%200-.322-.321h-5.777a.322.322%200%200%200-.321.32zm-1.926%201.605v-1.605a2.248%202.248%200%200%201%202.247-2.247h5.777a2.248%202.248%200%200%201%202.247%202.247v1.605h1.128c.51%200%20.999.204%201.36.566l2.082%202.082c.361.361.566.85.566%201.36v3.695h-5.136v-1.284c0-.71-.574-1.283-1.284-1.283-.71%200-1.284.573-1.284%201.283v1.284h-5.135v-1.284c0-.71-.574-1.283-1.284-1.283-.71%200-1.284.573-1.284%201.283v1.284H113v-3.695c0-.51.205-.999.566-1.36l2.082-2.082c.361-.362.85-.566%201.36-.566zM113%20166.407v-2.568h5.136c0%20.71.573%201.284%201.284%201.284.71%200%201.284-.574%201.284-1.284h5.135c0%20.71.574%201.284%201.284%201.284.71%200%201.284-.574%201.284-1.284h5.136v2.568a2.57%202.57%200%200%201-2.568%202.568h-15.407a2.57%202.57%200%200%201-2.568-2.568zM108.46%20118.307v1.605h6.419v-1.605a.322.322%200%200%200-.321-.32h-5.778a.322.322%200%200%200-.32.32zm-1.927%201.605v-1.605a2.248%202.248%200%200%201%202.247-2.247h5.778a2.248%202.248%200%200%201%202.247%202.247v1.605h1.127c.51%200%201%20.205%201.36.566l2.083%202.082c.36.361.566.85.566%201.36v3.696h-5.136v-1.284c0-.71-.574-1.284-1.284-1.284-.71%200-1.284.574-1.284%201.284v1.284h-5.136v-1.284c0-.71-.573-1.284-1.284-1.284-.71%200-1.284.574-1.284%201.284v1.284h-5.135v-3.696c0-.51.204-.999.565-1.36l2.083-2.082c.36-.361.85-.566%201.36-.566zm-5.135%2011.555V128.9h5.135c0%20.71.574%201.284%201.284%201.284.71%200%201.284-.574%201.284-1.284h5.136c0%20.71.574%201.284%201.284%201.284.71%200%201.284-.574%201.284-1.284h5.136v2.567a2.57%202.57%200%200%201-2.568%202.568h-15.407a2.57%202.57%200%200%201-2.568-2.568zM160.354%2055.2v1.605h6.42V55.2a.322.322%200%200%200-.322-.32h-5.777a.322.322%200%200%200-.321.32zm-1.926%201.605V55.2a2.248%202.248%200%200%201%202.247-2.247h5.777A2.248%202.248%200%200%201%20168.7%2055.2v1.605h1.128c.51%200%20.999.205%201.36.566l2.082%202.082c.361.361.566.85.566%201.36v3.696h-5.136v-1.284c0-.71-.573-1.284-1.284-1.284-.71%200-1.284.574-1.284%201.284v1.284h-5.135v-1.284c0-.71-.574-1.284-1.284-1.284-.71%200-1.284.574-1.284%201.284v1.284h-5.136v-3.696c0-.51.205-.999.566-1.36l2.082-2.082c.361-.361.85-.566%201.36-.566zm-5.136%2011.555v-2.567h5.136c0%20.71.574%201.284%201.284%201.284.71%200%201.284-.574%201.284-1.284h5.135c0%20.71.574%201.284%201.284%201.284.71%200%201.284-.574%201.284-1.284h5.136v2.567a2.57%202.57%200%200%201-2.568%202.568H155.86a2.57%202.57%200%200%201-2.568-2.568z%22%20style%3D%22stroke-width%3A.0401226%22%2F%3E%3Cpath%20d%3D%22M54.433%2035.642v1.105h4.42v-1.105c0-.122-.1-.221-.222-.221h-3.977c-.122%200-.221.1-.221.22zm-1.326%201.105v-1.105c0-.854.693-1.547%201.547-1.547h3.977c.854%200%201.547.693%201.547%201.547v1.105h.777c.35%200%20.687.14.936.39l1.434%201.433c.248.248.39.585.39.936v2.544h-3.537v-.883a.883.883%200%201%200-1.768%200v.883h-3.535v-.883a.883.883%200%201%200-1.768%200v.883H49.57v-2.544c0-.35.14-.688.39-.936l1.433-1.434c.249-.248.586-.39.936-.39zm-3.536%207.955v-1.768h3.536a.883.883%200%201%200%201.768%200h3.535a.883.883%200%201%200%201.768%200h3.536v1.768a1.77%201.77%200%200%201-1.768%201.768H51.34a1.77%201.77%200%200%201-1.768-1.768z%22%20style%3D%22stroke-width%3A.0276239%22%2F%3E%3Cpath%20d%3D%22M122.793%2012.205v3.278h13.111v-3.278a.657.657%200%200%200-.655-.656h-11.8a.657.657%200%200%200-.656.656zm-3.934%203.278v-3.278a4.592%204.592%200%200%201%204.59-4.59h11.8a4.592%204.592%200%200%201%204.588%204.59v3.278h2.303c1.04%200%202.04.418%202.778%201.155l4.253%204.253a3.933%203.933%200%200%201%201.155%202.778v7.547h-10.489v-2.622a2.62%202.62%200%200%200-2.622-2.622%202.62%202.62%200%200%200-2.622%202.622v2.622h-10.49v-2.622a2.62%202.62%200%200%200-2.621-2.622%202.62%202.62%200%200%200-2.623%202.622v2.622H108.37V23.67c0-1.04.418-2.04%201.156-2.778l4.253-4.253a3.934%203.934%200%200%201%202.778-1.155zm-10.489%2023.6v-5.245h10.49a2.62%202.62%200%200%200%202.622%202.623%202.62%202.62%200%200%200%202.622-2.623h10.489a2.62%202.62%200%200%200%202.622%202.623%202.62%202.62%200%200%200%202.622-2.623h10.49v5.245a5.25%205.25%200%200%201-5.245%205.244h-31.467a5.25%205.25%200%200%201-5.245-5.244z%22%20style%3D%22stroke-width%3A.0819451%22%2F%3E%3Cpath%20d%3D%22M24.863%2080.802v2.252h9.006v-2.252a.452.452%200%200%200-.45-.45h-8.106a.452.452%200%200%200-.45.45zm-2.702%202.252v-2.252a3.154%203.154%200%200%201%203.152-3.152h8.105a3.154%203.154%200%200%201%203.152%203.152v2.252h1.582c.715%200%201.402.287%201.908.794l2.921%202.92c.507.507.794%201.194.794%201.909v5.184H36.57V92.06a1.8%201.8%200%200%200-1.8-1.801%201.8%201.8%200%200%200-1.802%201.8v1.802h-7.205V92.06a1.8%201.8%200%200%200-1.8-1.801%201.8%201.8%200%200%200-1.802%201.8v1.802h-7.205v-5.184c0-.715.287-1.402.794-1.908l2.921-2.921a2.702%202.702%200%200%201%201.908-.794zm-7.205%2016.21v-3.602h7.205a1.8%201.8%200%200%200%201.801%201.801%201.8%201.8%200%200%200%201.801-1.8h7.205a1.8%201.8%200%200%200%201.801%201.8%201.8%201.8%200%200%200%201.801-1.8h7.205v3.602a3.606%203.606%200%200%201-3.602%203.602H18.559a3.606%203.606%200%200%201-3.603-3.602zM137.661%2098v2.251h9.006V98a.452.452%200%200%200-.45-.45h-8.106a.452.452%200%200%200-.45.45zm-2.702%202.251V98a3.154%203.154%200%200%201%203.152-3.152h8.106A3.154%203.154%200%200%201%20149.369%2098v2.251h1.581c.715%200%201.402.287%201.908.794l2.922%202.921c.506.507.793%201.194.793%201.908v5.184h-7.204v-1.8a1.8%201.8%200%200%200-1.801-1.802%201.8%201.8%200%200%200-1.802%201.801v1.801h-7.204v-1.8a1.8%201.8%200%200%200-1.802-1.802%201.8%201.8%200%200%200-1.8%201.801v1.801h-7.206v-5.184c0-.714.288-1.401.794-1.908l2.921-2.921a2.702%202.702%200%200%201%201.909-.794zm-7.205%2016.211v-3.602h7.205a1.8%201.8%200%200%200%201.801%201.8%201.8%201.8%200%200%200%201.802-1.8h7.204a1.8%201.8%200%200%200%201.801%201.8%201.8%201.8%200%200%200%201.802-1.8h7.204v3.602a3.606%203.606%200%200%201-3.602%203.602h-21.614a3.606%203.606%200%200%201-3.603-3.602z%22%20style%3D%22stroke-width%3A.0562868%22%2F%3E%3Cpath%20d%3D%22M50.207%20115.743v3.277h13.111v-3.277a.657.657%200%200%200-.655-.656h-11.8a.657.657%200%200%200-.656.656zm-3.933%203.277v-3.277a4.592%204.592%200%200%201%204.589-4.59h11.8a4.592%204.592%200%200%201%204.589%204.59v3.277h2.302c1.041%200%202.04.418%202.778%201.156l4.253%204.253a3.933%203.933%200%200%201%201.156%202.778v7.547H67.25v-2.622a2.62%202.62%200%200%200-2.622-2.623%202.62%202.62%200%200%200-2.622%202.623v2.622H51.518v-2.622a2.62%202.62%200%200%200-2.622-2.623%202.62%202.62%200%200%200-2.622%202.623v2.622h-10.49v-7.547c0-1.041.419-2.04%201.156-2.778l4.253-4.253a3.934%203.934%200%200%201%202.778-1.156zm-10.49%2023.6v-5.244h10.49a2.62%202.62%200%200%200%202.622%202.622%202.62%202.62%200%200%200%202.622-2.622h10.49a2.62%202.62%200%200%200%202.621%202.622%202.62%202.62%200%200%200%202.623-2.622H77.74v5.245a5.25%205.25%200%200%201-5.245%205.244H41.03a5.25%205.25%200%200%201-5.244-5.244z%22%20style%3D%22stroke-width%3A.0819451%22%2F%3E%3Cpath%20d%3D%22M55.755%2061.923v.99h3.958v-.99a.198.198%200%200%200-.198-.198h-3.562a.198.198%200%200%200-.198.198zm-1.188.99v-.99c0-.764.621-1.385%201.386-1.385h3.562c.765%200%201.386.62%201.386%201.385v.99h.695c.314%200%20.616.126.838.349l1.284%201.284c.223.222.35.524.35.838v2.279H60.9v-.792a.79.79%200%201%200-1.584%200v.792h-3.166v-.792a.79.79%200%201%200-1.584%200v.792h-3.166v-2.279c0-.314.126-.616.348-.838l1.284-1.284c.223-.223.525-.35.84-.35zm-3.166%207.125v-1.584h3.166a.79.79%200%201%200%201.584%200h3.166a.79.79%200%201%200%201.584%200h3.166v1.584c0%20.873-.71%201.583-1.583%201.583h-9.5c-.873%200-1.583-.71-1.583-1.583zM98.035%2052.665v.99h3.958v-.99a.199.199%200%200%200-.198-.198h-3.562a.199.199%200%200%200-.198.198zm-1.188.99v-.99c0-.764.621-1.385%201.386-1.385h3.562c.765%200%201.386.62%201.386%201.385v.99h.695c.314%200%20.616.126.838.349l1.284%201.284c.223.222.35.524.35.838v2.279h-3.167v-.792a.79.79%200%201%200-1.584%200v.792h-3.166v-.792a.79.79%200%201%200-1.584%200v.792h-3.166v-2.279c0-.314.126-.616.348-.838l1.284-1.284c.223-.223.525-.349.84-.349zm-3.166%207.125v-1.583h3.166a.79.79%200%201%200%201.584%200h3.166a.79.79%200%201%200%201.584%200h3.166v1.583c0%20.873-.71%201.583-1.583%201.583h-9.5c-.873%200-1.583-.71-1.583-1.583zM152.354%20158.385v.99h3.959v-.99a.199.199%200%200%200-.198-.197h-3.563a.199.199%200%200%200-.198.197zm-1.187.99v-.99c0-.764.62-1.385%201.385-1.385h3.563c.764%200%201.385.621%201.385%201.385v.99h.695c.314%200%20.616.126.839.349l1.284%201.284c.223.222.349.524.349.839v2.278H157.5v-.792a.79.79%200%201%200-1.583%200v.792h-3.167v-.792a.79.79%200%201%200-1.583%200v.792H148v-2.278c0-.315.126-.617.349-.84l1.284-1.283c.222-.223.524-.349.838-.349zM148%20166.5v-1.583h3.167a.79.79%200%201%200%201.583%200h3.167a.79.79%200%201%200%201.583%200h3.167v1.583c0%20.873-.71%201.583-1.584%201.583h-9.5c-.873%200-1.583-.71-1.583-1.583zM86.354%20167.385v.99h3.959v-.99a.198.198%200%200%200-.198-.197h-3.563a.199.199%200%200%200-.198.197zm-1.187.99v-.99c0-.764.62-1.385%201.385-1.385h3.563c.764%200%201.385.621%201.385%201.385v.99h.695c.314%200%20.616.126.839.349l1.284%201.284c.223.222.349.524.349.839v2.278H91.5v-.792a.79.79%200%201%200-1.583%200v.792H86.75v-.792a.79.79%200%201%200-1.583%200v.792H82v-2.278c0-.315.126-.617.349-.84l1.284-1.283c.222-.223.524-.349.838-.349zM82%20175.5v-1.583h3.167a.79.79%200%201%200%201.583%200h3.167a.79.79%200%201%200%201.583%200h3.167v1.583c0%20.873-.71%201.583-1.584%201.583h-9.5c-.873%200-1.583-.71-1.583-1.583ZM11.354%20112.385v.99h3.959v-.99a.198.198%200%200%200-.198-.197h-3.563a.199.199%200%200%200-.198.197zm-1.187.99v-.99c0-.764.62-1.385%201.385-1.385h3.563c.764%200%201.385.621%201.385%201.385v.99h.695c.314%200%20.616.126.839.349l1.284%201.284c.223.222.349.524.349.839v2.278H16.5v-.792a.79.79%200%201%200-1.583%200v.792H11.75v-.792a.79.79%200%201%200-1.583%200v.792H7v-2.278c0-.315.126-.617.349-.84l1.284-1.283c.222-.223.524-.349.838-.349zM7%20120.5v-1.583h3.167a.79.79%200%201%200%201.583%200h3.167a.79.79%200%201%200%201.583%200h3.167v1.583c0%20.873-.71%201.583-1.584%201.583h-9.5c-.873%200-1.583-.71-1.583-1.583ZM14.354%2060.385v.99h3.959v-.99a.198.198%200%200%200-.198-.197h-3.563a.198.198%200%200%200-.198.197zm-1.187.99v-.99c0-.764.62-1.385%201.385-1.385h3.563c.764%200%201.385.621%201.385%201.385v.99h.695c.314%200%20.616.126.839.349l1.284%201.284c.223.222.349.524.349.839v2.278H19.5v-.792a.79.79%200%201%200-1.583%200v.792H14.75v-.792a.79.79%200%201%200-1.583%200v.792H10v-2.278c0-.315.126-.617.349-.84l1.284-1.283c.222-.223.524-.349.838-.349zM10%2068.5v-1.583h3.167a.79.79%200%201%200%201.583%200h3.167a.79.79%200%201%200%201.583%200h3.167V68.5c0%20.873-.71%201.583-1.584%201.583h-9.5c-.873%200-1.583-.71-1.583-1.583ZM66.354%2012.385v.99h3.959v-.99a.198.198%200%200%200-.198-.197h-3.563a.198.198%200%200%200-.198.197zm-1.187.99v-.99c0-.764.62-1.385%201.385-1.385h3.563c.764%200%201.385.621%201.385%201.385v.99h.695c.314%200%20.616.126.839.349l1.284%201.284c.223.222.349.524.349.839v2.278H71.5v-.792a.79.79%200%201%200-1.583%200v.792H66.75v-.792a.79.79%200%201%200-1.583%200v.792H62v-2.278c0-.315.126-.617.349-.84l1.284-1.283c.222-.223.524-.349.838-.349zM62%2020.5v-1.583h3.167a.79.79%200%201%200%201.583%200h3.167a.79.79%200%201%200%201.583%200h3.167V20.5c0%20.873-.71%201.583-1.584%201.583h-9.5c-.873%200-1.583-.71-1.583-1.583Z%22%20style%3D%22stroke-width%3A.0247396%22%2F%3E%3Cpath%20d%3D%22M162.862%2013.547v1.105h4.42v-1.105c0-.122-.1-.221-.221-.221h-3.978c-.122%200-.221.1-.221.22zm-1.326%201.105v-1.105c0-.854.693-1.547%201.547-1.547h3.978c.853%200%201.547.693%201.547%201.547v1.105h.776c.35%200%20.688.14.936.39l1.434%201.433c.249.249.39.586.39.937v2.544h-3.536v-.884a.883.883%200%201%200-1.768%200v.884h-3.536v-.884a.883.883%200%201%200-1.768%200v.884H158v-2.544c0-.351.14-.688.39-.937l1.433-1.434c.249-.248.586-.39.937-.39zM158%2022.608V20.84h3.536a.883.883%200%201%200%201.768%200h3.536a.883.883%200%201%200%201.768%200h3.535v1.768a1.77%201.77%200%200%201-1.767%201.768h-10.608A1.77%201.77%200%200%201%20158%2022.608ZM126.351%2077.993v1.105h4.42v-1.105c0-.122-.1-.221-.22-.221h-3.979c-.121%200-.22.1-.22.22zm-1.326%201.105v-1.105c0-.854.694-1.547%201.547-1.547h3.978c.854%200%201.547.693%201.547%201.547v1.105h.776c.351%200%20.688.14.937.39l1.434%201.433c.248.249.39.586.39.936v2.545h-3.537v-.884a.883.883%200%201%200-1.768%200v.884h-3.536v-.884a.883.883%200%201%200-1.768%200v.884h-3.535v-2.545c0-.35.14-.687.39-.936l1.433-1.434c.248-.248.585-.39.936-.39zm-3.535%207.955v-1.768h3.535a.883.883%200%201%200%201.768%200h3.536a.883.883%200%201%200%201.768%200h3.536v1.768a1.77%201.77%200%200%201-1.768%201.768h-10.607a1.77%201.77%200%200%201-1.768-1.768zM159.23%20125.393v1.105h4.42v-1.105c0-.121-.099-.22-.22-.22h-3.978c-.122%200-.221.099-.221.22zm-1.325%201.105v-1.105c0-.853.693-1.547%201.547-1.547h3.978c.853%200%201.547.694%201.547%201.547v1.105h.776c.35%200%20.688.141.936.39l1.434%201.433c.249.25.39.586.39.937v2.544h-3.536v-.884a.883.883%200%201%200-1.768%200v.884h-3.536v-.884a.883.883%200%201%200-1.768%200v.884h-3.536v-2.544c0-.35.14-.688.39-.937l1.433-1.433c.249-.249.586-.39.937-.39zm-3.536%207.956v-1.768h3.536a.883.883%200%201%200%201.768%200h3.536a.883.883%200%201%200%201.768%200h3.535v1.768a1.77%201.77%200%200%201-1.767%201.768h-10.608a1.77%201.77%200%200%201-1.768-1.768z%22%20style%3D%22stroke-width%3A.0276239%22%2F%3E%3C%2Fsvg%3E");
    background-size: 300px 300px, 400px 400px, 600px 600px;
    background-blend-mode: lighten;
    background-color: color-mix(in srgb, var(--f-f7) 97%, transparent);
  }

  .container {
    position: relative;
    z-index: 1;
  }

  h1{
    color: var(--f-d1);
    font-size: 5rem;
    font-weight: 300;
    margin: 4rem 0 3rem;

    @media (max-width: 992px) {
      font-size: 4rem;
      margin: 3rem 0 2rem;
    }

    @media (max-width: 768px) {
      font-size: 3rem;
      margin: 2rem 0 1.5rem;
    }
  }

  h2 {
    color: var(--f-d1);
    font-size: 2rem;
    font-weight: 300;
    line-height: 1.25;
    margin: 0;

    @media (max-width: 992px) {
      font-size: 1.75rem;
    }

    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
  }

  p {
    color: var(--f-d1);
  }

  .actions {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin: 3rem auto 5.5rem;

    @media (max-width: 768px) {
      margin: 2rem 0 0.5rem;
      flex-direction: column;
    }

    a.btn {
      text-align: start;
      width: 100%;
      span {
        text-transform: uppercase;
      }

      @media (max-width: 992px) {
        padding: .5rem 1rem;
      }

      @media (max-width: 768px) {
        margin: .125rem 0;
      }

      &:first-of-type {
        margin-left: 0;
      }
    }

    .btn-primary {
      background: var(--f-d1);
      color: var(--f-o7);
      font-weight: 700;
      border: none;

      &:focus, &:hover {
        background: var(--f-o7);
        color: var(--f-d1);
      }

      i::before {
        color: inherit;
      }
    }
  }

  .btn-outline-light {
    @media (min-width: 768px) {
      border: transparent;
    }
  }

  img {
    max-height: 25vh;
      border-radius: 1.3rem;

    @media (min-width: 992px) {
      max-height: initial;
    }
  }

  #learn-more {
    label {
      color: var(--f-d1);
      background: none;
      text-decoration: none;

      i::before {
        color: var(--f-d1);
      }
    }

    span {
      padding: .25rem ;
      font-size: .875rem;
    }

    input:checked ~ label {
      visibility: hidden;
    }
  }
}

#what {
  padding: 4rem 0;

  h2 {
    text-align: center;
    text-transform: uppercase;
    margin-bottom: 2rem;

    @media (min-width: 768px) {
      font-size: 3rem;
      line-height: 4rem;
    }
  }

  .card-header {
    border: none;
    background: transparent;
    padding: 0;

    .nav li {
      background: var(--f-g1);
      padding: 0.75rem 1.25rem;
    }
  }

  .card-body .row {
    align-items: center
  }

  h3 {
    font-size: 3rem;
    font-weight: 300;
    letter-spacing: -1px;
    line-height: 1;
    margin: .5rem 0 1rem;

    @media (max-width: 992px) {
      font-size: 2rem;
    }

    @media (max-width: 768px) {
      font-size: 1.75rem;
    }
  }

  p {
    font-size: 1.35rem;
    font-weight: 200;
    line-height: 1.4;

    @media (max-width: 992px) {
      font-size: 1rem;
    }
  }
}

/* SFS */
#support {
  @media (min-width: 992px) { /* cat is hidden by the form below 992px */
    background:
      transparent
      url('../../public/img/gattino-galileo.png')
      no-repeat
      10% calc(100% + 40px);
  }

  .col-lg-7 .ombre {
    margin-top: 3rem;
    margin-bottom: 1rem;
  }
}

@media (min-width: 992px) {
  #f-sfs + div { /* #outro parent */
    background:
      transparent
      url('../../public/img/gattino-galileo.png')
      no-repeat
      10% calc(100% + 20px);
  }
}

/* Framanav */
#home #fp-alert {
  background: var(--f-d1);
}

.f-bs4 #f-footer {
  border: none !important;
}
</style>
